import { Box, Button, Stack, Typography, MenuItem, Menu, CircularProgress, Grid, Collapse, FormControl, TextField, Autocomplete, InputAdornment, Breadcrumbs, Link, Dialog, DialogContent, DialogActions } from "@mui/material";
import { connect } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { ArrowForwardIos } from "@mui/icons-material";
import UserGrid from "./UserGrid";
import { actionCreators } from "../../store";
import FetchHelper from "../FetchHelper";
import { WIDTH_AGGRID, WIDTH_DASHBOARD_LEFT } from "../../models/Constants";
import { useForm } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";
import { Path as RoutePath } from "../../path";
import { PageData } from "../../models/Index";
import AddEditUserDialog from "../dialogs/AddEditUserDialog";

const GET_USER_LIST = "GET_USER_LIST"
const ADD_USER = "ADD_USER"
const EDIT_USER = "EDIT_USER"
const DELETE_USER = "DELETE_USER"

// 検索フォーム
interface SearchItemForm {
    "target": string;
    "limit": number;
    "page": number;
}

// 初期値設定
const initialValue: SearchItemForm = {
    target: '',
    limit: 50,
    page: 1
}

const initialPageData: PageData = {
    rowFrom: '0',
    rowTo: '0',
    totalRow: '0',
    currPage: '0',
    totalPage: '0',
};

export type UserList = 
    ReturnType<typeof mapStateToProps> 
    & ReturnType<typeof mapDispatchToProps>
export const UserList = (props: UserList) => {
    //#region Fields
    const {
        attribute,
        onGet,
        onAddUser,
        onEditUser,
        onAddUserSuccess,
        onAddUserError,
        onEditUserSuccess,
        onEditUserError,
        onDeleteUser,
        onDeleteUserSuccess,
        onDeleteUserError,
    } = props;

    const [dataSelected,setDataSelected] = useState<any>(null)
    const [loadingFlag, setLoadingFlag] = useState(false);

    const [openUserDialog, setOpenUserDialog] = useState<{isOpen:boolean,mode:'UPDATE'|'ADD'}>({isOpen:false,mode:'ADD'})
    const [openDeleteUserDialog, setOpenDeleteUserDialog] = useState(false)
    const [dataUserDialog,setDataUserDialog] = useState<any>({})

    const [pageData, setPageData] = useState(initialPageData);

    const [keyword,setKeyword] = useState<any>('');
    const navigate = useNavigate()

    let grifUserList = useRef<any>()

     const { control, handleSubmit, setValue, getValues } = useForm<SearchItemForm>({
            criteriaMode: "all",
            defaultValues: initialValue,
        });

    const handleGetUserList =(value: SearchItemForm) =>{
        setDataSelected(null)
        setLoadingFlag(true)
        const params = new Map<string, any>();
        if (value.limit) params.set("limit", value.limit);
        params.set("page", value.page);

        onGet({limit: value.limit,
                    page: value.page})
    }

    useEffect(() =>{
        handleGetUserList(getValues())
    },[])

    const handleClickAddButton =() =>{
        setOpenUserDialog({isOpen:true,mode:'ADD'})
    }

    const handleClickEditButton =(data:any) =>{
        setDataSelected(data)
        setDataUserDialog({
            userName: data.userName,
            email: data.email,
            dateOfBirth: data.dateOfBirth
        })
        setOpenUserDialog({isOpen:true,mode:'UPDATE'})
    }

    const handleChecked = (data:any) =>{
    }

    const handleChangePageData = (name: any, value: any) => {
        // 値変更
        setValue(name, value);
        if (name === 'limit') {
            setValue("page", 1);
        }
        setLoadingFlag(true)
        handleGetUserList(getValues());
    };

    const handleGetUserListSuccess = (data:any) => {
        if (grifUserList && grifUserList.current) {
            grifUserList.current?.setRowData(data.data.data);
            
            const totalCount = data.data.totalCount;
            const pageSize = getValues('limit');
            const page = Number(data.data.page);
            const totalPage = Math.ceil(totalCount / pageSize);
            const rowFrom = (pageSize * page - pageSize) + 1;
            const rowTo = (pageSize * page) > totalCount ? totalCount : (pageSize * page);
            const updateData: PageData = {
                rowFrom: rowFrom.toLocaleString(),
                rowTo: rowTo.toLocaleString(),
                totalRow: totalCount.toLocaleString(),
                currPage: page.toLocaleString(),
                totalPage: totalPage.toLocaleString(),
            };
            setPageData(updateData);
        }
        else{
            grifUserList.current.setRowData([])
        }
        setLoadingFlag(false)
    }

    const handleGetUserListError = (data:any) => {
        setLoadingFlag(false)
    }

    const handleAddUserSuccess = (data:any) => {
        setDataUserDialog({})
        setDataSelected(null)
        setOpenUserDialog({isOpen:false,mode:'ADD'})
        onAddUserSuccess()
        handleGetUserList(getValues())
    }

    const handleAddUserError = (data:any) => {
        setLoadingFlag(false)
        onAddUserError()
    }

    const handleEditUserSuccess = (data:any) => {
        setDataUserDialog({})
        setDataSelected(null)
        setOpenUserDialog({isOpen:false,mode:'ADD'})
        onEditUserSuccess()
        handleGetUserList(getValues())
    }

    const handleEditUserError = (data:any) => {
        setLoadingFlag(false)
        onEditUserError()
    }

    const handleDeleteUserSuccess = (data:any) => {
        setDataUserDialog({})
        setDataSelected(null)
        setOpenUserDialog({isOpen:false,mode:'ADD'})
        onDeleteUserSuccess()
        handleGetUserList(getValues())
    }

    const handleDeleteUserError = (data:any) => {
        setLoadingFlag(false)
        onDeleteUserError()
    }

    const handleOKUserDialog = (data:any) => {
        setLoadingFlag(true)
        if(data.mode == 'ADD')
        {
            onAddUser({
                userName: data.userName,
                email: data.email,
                dateOfBirth: data.dateOfBirth
            })
        }
        else
        {
            onEditUser({
                userId: dataSelected.userId,
                userName: data.userName,
                email: data.email,
                dateOfBirth: data.dateOfBirth
            })
        }
    }

    const handleDeleteUser = () => {
        setLoadingFlag(true)
        setOpenDeleteUserDialog(false)
        onDeleteUser({
            userId: dataSelected.userId
        })
    }

	return (          
        <>
            {loadingFlag && (
                        <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                            <CircularProgress />
                        </div>
                )}
            <Stack position='absolute' style={{ marginLeft:WIDTH_DASHBOARD_LEFT,marginTop:"20px"}} width={WIDTH_AGGRID}>
                <Breadcrumbs sx={{height:"50px",alignItems:"center",display:"flex",flexDirection:"row", marginLeft:"20px", fontSize:22}}  separator={<ArrowForwardIos fontSize='small' sx={{color:"black"}}/>} aria-label="breadcrumb">
                    <Link underline="hover" key="1" color="black" href={undefined} onClick={()=> navigate(RoutePath.home,{state:{isTestList:false,isUserList:true,isSetting:false}})} ml={2} >
                    受検者管理
                    </Link>
                    <Typography key="2" sx={{ color: 'text.primary' }} noWrap fontSize={22}>
                    受検者一覧
                    </Typography>,
                </Breadcrumbs>
               
                <Stack direction='row' spacing={2} justifyContent={"flex-end"} alignItems={"center"} mr={10} mt={1}>
                    <Box marginRight={2} width={"18vw"}>
                        <TextField
                            fullWidth
                            autoComplete="searchStr"
                            name="keyword"
                            type="text"
                            label="フィルター"
                            size="small"
                            value={keyword}
                            onChange={e =>  {setKeyword(e.target.value)}}
                            InputProps={{
                                sx: { borderRadius: "8px" },
                                startAdornment:null,
                                endAdornment:(
                                <InputAdornment position="end">
                                    <SearchIcon/>
                                </InputAdornment>)
                            }}
                        />
                    </Box>
                    <Box marginRight={2}>
                        <Button variant="outlined" onClick={e => {setKeyword("")}}>クリア</Button>
                    </Box>
                    <Button variant="contained" sx={{fontWeight:'bold'}} onClick={handleClickAddButton}>追加</Button>
                </Stack>
                
                <Stack marginLeft={5} mr={10} mt={1}>
                    <UserGrid 
                        ref={grifUserList} 
                        keyword={keyword} 
                        onSelected={handleChecked} 
                        onDoubleClick={handleClickEditButton} 
                        isSearch={dataSelected == null?true:false}
                        pageData={pageData}
                        pageSize={getValues('limit')}
                        onChangeSearchCondition={handleChangePageData}
                        onDeleteUser={(data:any)=>{setDataSelected(data);setOpenDeleteUserDialog(true)}}
                    />
                </Stack>
            </Stack>

            {openUserDialog.isOpen && <AddEditUserDialog data={dataUserDialog} mode={openUserDialog.mode} onCancel={() =>setOpenUserDialog({isOpen:false,mode:'ADD'})} onOK={handleOKUserDialog}/>}
            {openDeleteUserDialog &&
                <Dialog
                    open={true}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiPaper-root': {
                        borderRadius: '8px',
                        border:"1px solid black",
                        width:"50vw"
                        },
                    }}
                    >
                    <DialogContent>
                            <Box>
                                {`受検者「${dataSelected?.userName??""}」を削除しますか？`}
                            </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() =>setOpenDeleteUserDialog(false)} color="inherit" variant="contained" sx={{fontWeight:'bold'}}>キャンセル</Button>
                        <Button variant="contained" onClick={handleDeleteUser}>削除</Button>
                    </DialogActions>
                </Dialog>
            }
            <FetchHelper 
                fetchId={GET_USER_LIST} 
                onComplete={(success,data,error)=>success?
                    handleGetUserListSuccess(data):
                    handleGetUserListError(data)}
            ></FetchHelper>
            <FetchHelper 
                fetchId={ADD_USER} 
                onComplete={(success,data,error)=>success?
                    handleAddUserSuccess(data):
                    handleAddUserError(data)}
            ></FetchHelper>
            <FetchHelper 
                fetchId={EDIT_USER} 
                onComplete={(success,data,error)=>success?
                    handleEditUserSuccess(data):
                    handleEditUserError(data)}
            ></FetchHelper>
            <FetchHelper 
                fetchId={DELETE_USER} 
                onComplete={(success,data,error)=>success?
                    handleDeleteUserSuccess(data):
                    handleDeleteUserError(data)}
            ></FetchHelper>
        </>  
    );
};

const mapStateToProps = (state: any) => {
    return {
        attribute: state.app?.user,
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        onGet: (params: any ) => dispatch(actionCreators.fetch(GET_USER_LIST,"/user/get-list-user","POST",params,false,true)),
        onAddUser:(params:any)=>dispatch(actionCreators.fetch(ADD_USER,'/user/add-user',"POST",params,false,true)),
        onEditUser:(params:any)=>dispatch(actionCreators.fetch(EDIT_USER,'/user/edit-user',"POST",params,false,true)),
        onDeleteUser:(params:any)=>dispatch(actionCreators.fetch(DELETE_USER,'/user/delete-user',"POST",params,false,true)),

        onAddUserSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "ユーザー情報追加",
            body: "ユーザー情報を登録しました。",
                })),
        onAddUserError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "ユーザー情報追加",
            body: "ユーザー情報が登録出来ませんでした。",
                })),

        onEditUserSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "ユーザー情報編集",
            body: "ユーザー情報が更新されました。",
                })),
        onEditUserError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "ユーザー情報編集",
            body: "ユーザー情報が更新出来ませんでした。",
                })),
        onDeleteUserSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "ユーザー情報削除",
            body: "ユーザー情報を削除しました。",
                })),
        onDeleteUserError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "ユーザー情報削除",
            body: "ユーザー情報が削除出来ませんでした。",
                }))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserList);